// @flow

import * as React from 'react';
import {defineMessages, useIntl} from 'react-intl';
import {BodyMono} from 'sail/Text';

import {TriggerTree} from '../helpers/commands/triggers';
import {TriggerResponse} from '../helpers/commands/fixture';

const messages = defineMessages({
  triggerHelp: {
    id: 'docsApp.stripeShell.triggerHelp',
    description: 'Help text that appears when the user types `stripe trigger`.',
    defaultMessage: `
Trigger specific webhook events to be sent. Webhooks events created through
the trigger command will also create all necessary side-effect events that are
needed to create the triggered event as well as the corresponding API objects.

Supported events:{supportedEvents}

Usage:
  stripe trigger [event]

Example:
  stripe trigger payment_intent.created
`,
  },
});

const supportedEvents = Object.keys(TriggerTree).reduce(
  (listed, eventType) => `${listed}\n  ${eventType}`,
  '',
);

export const TriggerHelp = () => {
  const {formatMessage} = useIntl();

  return (
    <BodyMono color="gray200" style={{whiteSpace: 'pre-wrap'}}>
      {formatMessage(messages.triggerHelp, {supportedEvents}).trim()}
    </BodyMono>
  );
};

export const trigger = ({
  args,
  params,
  apiKey,
  setAllowInput,
}: {
  args: Array<string>,
  params: {[string]: string},
  apiKey: string,
  setAllowInput: (boolean) => void,
}) => {
  if (args.length !== 1) {
    setAllowInput(true);
    return <TriggerHelp />;
  }

  if (!(args[0] in TriggerTree)) {
    setAllowInput(true);
    return `This is not a valid argument for stripe trigger: ${args[0]}`;
  }
  const fixtureConfig = TriggerTree[args[0]];

  return (
    <TriggerResponse
      fixtureConfig={fixtureConfig}
      api_key={apiKey}
      setAllowInput={setAllowInput}
    />
  );
};
